import React from 'react';
import styled from '@emotion/styled';

import { Typography } from '@mui/material';

export const Description = ({ children, ...props }) => (
  <Typography component="p" {...props}>
    {children}
  </Typography>
);

export const TooltipLink = styled.a`
  text-decoration: underline;
`;
